import { TvInteriorIdCache } from '../Caches/TvInteriorIdCache';
import { DataCache } from '../../DataCache';
import { TvNumberParser } from './TvNumberParser';
export class TvBaseFormatter {
    constructor(symbol) {
        const interiorId = TvInteriorIdCache.getInteriorId(symbol);
        this.instrument = DataCache.getInstrumentByName(interiorId);
    }
    parse(value) {
        const formatterResult = {
            res: true,
            value: TvNumberParser.parse(value) // TODO return ErrorFormatterParseResult in case of error
            // suggest?: string;
        };
        return formatterResult;
    }
}
